var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-pago'),_vm._v(" "),_c('status',{attrs:{"img":(_vm.$S3 + "waiting-1.svg"),"text-one":"ESTA SIENDO","text-two":"PROCESADO"}}),_vm._v(" "),_c('section-help'),_vm._v(" "),_c('footer-pago')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58e33f5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page-pago-proceso.vue
// module id = 642
// module chunks = 3